import * as React from 'react';

/**
 * Spinner SVG for loading purposes
 *
 * @returns
 */
function CalendarSVG(svgProps: SVGProps) {
	return (
		<svg
			viewBox="0 0 30 32"
			className={'icon ' + svgProps.class}
			focusable="false"
			aria-hidden="true"
			data-testid={svgProps.testId}
		>
			<path
				fill="#929fb3"
				d="M27.429 31.998h-25.144c-0.011 0-0.024 0-0.038 0-1.227 0-2.224-0.983-2.247-2.204l-0-0.002v-24.274c0.022-1.224 1.020-2.208 2.247-2.208 0.013 0 0.026 0 0.039 0l-0.002-0h2.286v1.104c0.068 1.841 1.577 3.307 3.428 3.307s3.36-1.466 3.428-3.301l0-0.006v-1.104h6.856v1.104c0.068 1.841 1.577 3.307 3.428 3.307s3.36-1.466 3.428-3.301l0-0.006v-1.104h2.285c0.012-0 0.026-0 0.040-0 1.227 0 2.225 0.984 2.247 2.206l0 0.002v24.276c-0.024 1.223-1.021 2.205-2.247 2.205-0.013 0-0.026-0-0.040-0l0.002 0zM27.429 11.034h-25.144v18.758h25.144zM8 16.552h-3.429v-3.312h3.429zM8 22.070h-3.429v-3.312h3.429zM8 27.588h-3.429v-3.312h3.429zM13.714 16.553h-3.429v-3.313h3.429zM13.714 22.071h-3.429v-3.313h3.429zM13.714 27.589h-3.429v-3.313h3.429zM19.428 16.555h-3.429v-3.315h3.429zM19.428 22.073h-3.429v-3.315h3.429zM19.428 27.59h-3.429v-3.315h3.429zM25.142 16.556h-3.429v-3.316h3.429zM25.142 22.074h-3.429v-3.316h3.429zM25.142 27.592h-3.429v-3.316h3.429zM21.679 6.62c-0.012 0-0.025 0-0.039 0-1.208 0-2.189-0.968-2.212-2.17l-0-0.002v-2.276c0.055-1.2 1.041-2.152 2.25-2.152s2.195 0.952 2.25 2.147l0 0.005v2.276c-0.022 1.204-1.004 2.172-2.212 2.172-0.013 0-0.026-0-0.039-0l0.002 0zM7.965 6.62c-0.012 0-0.025 0-0.039 0-1.208 0-2.189-0.968-2.212-2.17l-0-0.002v-2.276c0.055-1.2 1.041-2.152 2.25-2.152s2.195 0.952 2.25 2.147l0 0.005v2.276c-0.023 1.205-1.005 2.172-2.213 2.172-0.013 0-0.025-0-0.038-0l0.002 0z"
			/>
		</svg>
	);
}

CalendarSVG.defaultProps = { class: '' };

export default CalendarSVG;
